<template>
  <v-container fluid class="px-0 mx-0">
    <!-- Temperature Chart -->
    <template v-if="!isLoading">
      <highcharts
        v-if="!isLoading"
        ref="highchart"
        :constructor-type="'stockChart'"
        :options="temperatureChartOptions"
      ></highcharts>

      <highcharts
        v-if="!isLoading"
        ref="highchart2"
        :constructor-type="'stockChart'"
        :options="rainChartOptions"
      ></highcharts>

      <highcharts
        v-if="!isLoading"
        ref="highchart3"
        :constructor-type="'stockChart'"
        :options="windChartOptions"
      ></highcharts>

      <highcharts
        v-if="!isLoading"
        ref="highchart4"
        :constructor-type="'stockChart'"
        :options="pressureChartOptions"
      ></highcharts>
    </template>
    <template v-else>
      <v-skeleton-loader type="card"></v-skeleton-loader>
    </template>
  </v-container>
</template>

<script>
/* eslint-disable */

import { ref } from "vue";

import moment from "moment";

// Components

// Highcharts
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import stockInit from "highcharts/modules/stock";

// API helper
import api from "../../api";

import cardinals from "../../cardinals";
import { iconUrl } from "../../iconUrl";
import { mapState } from 'vuex';

// Load the full build.
var _ = require("lodash");

stockInit(Highcharts);

export default {
  name: "Prévisions",

  components: {
    highcharts: Chart,
  },

  data: () => ({
    isLoading: false,
    forecasts: [],
    userAlerts:[],
  }),

  computed: {
    ...mapState(['user', 'model']),
    temperatureChartOptions() {
      let series = [];
      let tmaxData = [];
      let tsData = [];
      let dewPoint = [];
      let forecasts = this.forecasts;

      // if(this.userAlerts)
      // {
      //   let tempMinAlertTempMin = this.userAlerts.find(map=>map.key == "temp-min").number;
      //   let tempMinAlertTempMax = tempMinAlertTempMin - 100; 
      // }

      let formatIcon = this.formatIcon;

      let night = [];
      let actualNight = {};
      let values = [];

      // Loop trough forecasts array and push [time, value]
      forecasts.forEach((previ, index) => {
        // if (index === 0) this.startHour = previ.date;
        tmaxData.push({
          x: moment.utc(previ.date).unix() * 1000,
          y: +previ.tmax * 100 / 100,
        });
        values.push(Math.ceil(previ.tmax));

        tsData.push({
          x: moment.utc(previ.date).unix()  * 1000,
          y: +previ.tmax + 5,
          marker: {
            symbol: `url(${formatIcon(index)})`,
            height: 20,
            width: 20,
          },
        });

        dewPoint.push({
          x: moment.utc(previ.date).unix() * 1000,
          y: previ.dpt2m ? Math.round(+previ.dpt2m * 100) / 100 : Math.round(+previ.dptmin * 100) / 100,
        });
        
        values.push(Math.ceil(previ.dpt2m));

        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment.utc(previ.date).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index + 1 === forecasts.length)
        ) {
          actualNight.to = moment.utc(forecasts[index - 1].date).unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });

      let max = _.max(values) + 5;
      let min = _.min(values);
      if(!max) return;
      
      // Push data into series array
      series.push({
        showInLegend: false,
        color: "#ff0000",
        data: tmaxData,
        yAxis: 1,
        name: this.$t("forecasts.temperatureChart.title1"),
        states: {
          hover: {
            enabled: false,
          },
        },
      });

      series.push({
        color: "#ff0000",
        data: tsData,
        type: "scatter",
        yAxis: 0,
        name: this.$t("forecasts.temperatureChart.title1"),
        states: {
          hover: {
            enabled: false,
          },
        },
      });

      series.push({
        color: "#1dff00",
        data: dewPoint,
        yAxis: 1,
        name: this.$t("forecasts.temperatureChart.title2"),
        states: {
          hover: {
            enabled: false,
          },
        },
      });


      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];
            if(!this.points) return;
            this.points.forEach((point, index) => {
              console.log(index)
              tooltipArray.push(
                point.series.name + ": " + point.y.toFixed(1) + "</b>"
              );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          ordinal: false,
          plotLines: [
            {
              value: new Date(),
              width: 1,
              color: "green",
              dashStyle: "dash",
              label: {
                text: "Actuellement",
                align: "right",
                y: 100,
                x: 0,
              },
            },
          ],
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            min: min,
            max: max,
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("forecasts.temperatureChart.legend1"),
            },
            opposite: false,
          },
          {
            min:min,
            max:max,
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("forecasts.temperatureChart.legend1"),
            },
          },
          {
            min:min,
            max:max,
            labels: {
              enabled: false,
            },
            title: {
              text: this.$t("forecasts.temperatureChart.legend2"),
            },
          },
        ],
        // Labels Options
        plotOptions: {
          series: {
            states: {
              inactive: {
                opacity: 1,
              },
            },
          },
          line: {
            dataLabels: {
              useHTML: true,
              enabled: false,
              // allowOverlap: true,
              verticalAlign: "top",
              align: "center",
              x: 0, // Offset des points
              y: -22,
              padding: 0,
              style: {
                fontSize: "12px",
              },
            },
            enableMouseTracking: true,
          },
        },
        chart: {
          animation: false,
        },
        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
          outlineWidth: 0,
          maskFill: 'rgba(0, 0, 0, 0.2)',
          handles: {
            backgroundColor: '#eee',
            borderColor: '#777'
          },
          series: {
            type: 'areaspline',
            color: '#bbb'
          }
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                yAxis: [
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                ],
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            },
          ],
        },
      };
    },

    rainChartOptions() {
      let series = [];
      let rain = [];
      let snow = [];
      let rainMin = [];
      let etp = [];
      let forecasts = this.forecasts;

      let night = [];
      let actualNight = {};

      let max = 10;
      let min = 0;

      // Loop trough forecasts array and push [time, value]
      forecasts.forEach((previ, index) => {
        // Rain or Snow data
        if (previ.csnowsfc > 0) {
          snow.push([moment.utc(previ.date).unix() * 1000,
            Math.round(((previ.apcpsfc * previ.csnowsfc * 8) / 10) * 10) / 10,
          ]);

          if (previ.csnowsfc > max)
            max = Math.ceil(((previ.apcpsfc * previ.csnowsfc * 8) / 10) * 10);
        } else {
          rain.push([moment.utc(previ.date).unix() * 1000,
            previ.apcpsfc ? Math.round(+previ.apcpsfc * 10) / 10 : +previ.rainmaxhor,
          ]);
          if (previ.apcpsfc > max) max = Math.ceil(previ.apcpsfc);
        }

        etp.push([moment.utc(previ.date).unix() * 1000,
          parseFloat(-previ.etp),
        ]);

        if (-previ.etp < min) min = min = -previ.etp;

        // Humidity
        rainMin.push([
          moment.utc(previ.date).unix() * 1000,
          Math.floor(previ.rhmin),
        ]);

        // Night data
        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment.utc(previ.date).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index === forecasts.length - 1)
        ) {
          actualNight.to = moment.utc(forecasts[index - 1].date).unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });

      // Push data into series array
      if (snow.length > 0) {
        series.push({
          type: "column",
          name: "Neige (cm)",
          data: snow,
          color: "grey",
          yAxis: 2,
        });
      }
      series.push({
        type: "column",
        name: this.$t("forecasts.rainChart.title1"),
        data: rain,
        yAxis: 0,
      });
      series.push({
        data: rainMin,
        color: "#030D6B",
        name: this.$t("forecasts.rainChart.title3"),
        yAxis: 1,
      });

      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];

            this.points.forEach((point, index) => {
              console.log(index)
              point.series.name === "ETP (mm)"
                ? tooltipArray.push(
                    point.series.name + ": " + point.y.toFixed(1) * -1 + "</b>"
                  )
                : tooltipArray.push(
                    point.series.name + ": " + point.y.toFixed(1) + "</b>"
                  );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          ordinal: false,
          plotLines: [
            {
              value: new Date(),
              width: 1,
              color: "green",
              dashStyle: "dash",
              label: {
                text: "Actuellement",
                align: "right",
                y: 100,
                x: 0,
              },
            },
          ],
          // tickInterval: 1 * 36e5,
          // gridLineWidth: 1,
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            tickAmount: 7,
            min: 0,
            max: max,
            labels: {
              format: "{value:.0f}",
            },
            title: {
              text: "Pluie",
            },
            opposite: false,
          },
          {
            tickAmount: 3,
            min: 0,
            max: 100,
            labels: {
              format: "{value:.0f}",
            },
            title: {
              text: this.$t("forecasts.rainChart.legend2"),
            },
          },
          {
            // tickAmount: 7,
            min: 0,
            max: 10,
            labels: {
              enabled: false,
              format: "{value:.0f}",
            },
            opposite: false,
          },
        ],
        plotOptions: {
          series: {
            showInNavigator: true,
          },
          column: {
            dataLabels: {
              verticalAlign: "top",
              x: 0,
              y: -22,
              padding: 0,
              align: "center",
              enabled: true,
              style: {
                fontSize: "12px",
              },
              formatter: function () {
                // if (this.point.index % 3 === 0){
                let value = Math.round(this.y * 100) / 100;
                if (value > 0) {
                  return String(value).replaceAll(".", ",");
                } else {
                  return "";
                }
                // }
              },
            },
            enableMouseTracking: true,
          },
        },
        // chart: {
        //   height: 180,
        // },

        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                yAxis: [
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                ],
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            },
          ],
        },
      };
    },

    windChartOptions() {
      let series = [];
      let windSpeed = [];
      let gust = [];
      let forecasts = this.forecasts;
      let getArrow = this.getArrow;

      let night = [];
      let actualNight = {};

      let max = 0;

      // Loop trough forecasts array and push [time, value]
      forecasts.forEach((previ, index) => {
        windSpeed.push([moment.utc(previ.date).unix() * 1000,
          Math.floor(previ.wind_speed * 3.6),
        ]);

        gust.push([moment.utc(previ.date).unix() * 1000,
          Math.ceil(previ.gustsfc * 3.6),
        ]);

        if (previ.gustsfc * 3.6 > max) max = Math.ceil(previ.gustsfc * 3.6);

        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment.utc(previ.date).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index === forecasts.length - 1)
        ) {
          actualNight.to = moment.utc(forecasts[index - 1].date).unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });

      max += 10;

      // Push data into series array
      series.push({
        color: "#0037ff",
        data: windSpeed,
        yAxis: 0,
        name: this.$t("forecasts.windChart.title1"),
        dataLabels: {
          align: "top",
          formatter() {
            if (this.point.index % 3 === 0)
              return `<p><i class="fas fa-long-arrow-alt-up"
                    style="margin-left:5px;transform: rotate(${getArrow(
                      cardinals(Math.round(forecasts[this.point.index].dir))
                    )}deg)"
                  ></i></p>`;
          },
        },
      });

      series.push({
        color: "#ff0000",
        data: gust,
        yAxis: 0,
        dataGrouping:{
          enabled:false,
        },
        name: this.$t("forecasts.windChart.title2"),
        dataLabels: {
          enabled: false,
        },
      });

      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];

            this.points.forEach((point, index) => {
              console.log(index)
              tooltipArray.push(
                point.series.name + ": " + point.y.toFixed(1) + "</b>"
              );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          ordinal: false,
          plotLines: [
            {
              value: new Date(),
              width: 1,
              color: "green",
              dashStyle: "dash",
              label: {
                text: "Actuellement",
                align: "right",
                y: 100,
                x: 0,
              },
            },
          ],
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            tickAmount: 3,
            tickInterval: 10,
            min: 0,
            max: max,
            labels: {
              format: "{value}",
            },
            opposite: false,
            title: {
              text: this.$t("forecasts.windChart.legend1"),
            },
          },
          {
            tickAmount: 3,
            tickInterval: 10,
            min: 0,
            max: max,
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("forecasts.windChart.legend1"),
            },
          },
          {
            tickAmount: 3,
            tickInterval: 10,
            min: 0,
            max: max,
            labels: {
              enabled: false,
            },
            title: {
              text: this.$t("forecasts.windChart.legend2"),
            },
          },
        ],
        // Labels Options
        plotOptions: {
          line: {
            dataLabels: {
              useHTML: true,
              enabled: true,
              verticalAlign: "top",
              align: "center",
              x: 0, // Offset des points
              y: -22,
              padding: 0,
              style: {
                fontSize: "12px",
              },
            },
            enableMouseTracking: true,
          },
        },

        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                yAxis: {
                  labels: {
                    align: "left",
                    x: 0,
                    y: -5,
                  },
                  title: {
                    text: null,
                  },
                },
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            },
          ],
        },
      };
    },

    pressureChartOptions() {
      let series = [];
      let pressure = [];
      let forecasts = this.forecasts;

      let night = [];
      let actualNight = {};

      let max = 0;
      let min = 10000;

      // Loop trough forecasts array and push [time, value]
      forecasts.forEach((previ, index) => {
        pressure.push([moment.utc(previ.date).unix() * 1000,
          Math.floor(previ.prmslmsl),
        ]);
        if (parseInt(previ.prmslmsl) > max) {
          max = previ.prmslmsl;
        }
        if (parseInt(previ.prmslmsl) < min) {
          min = previ.prmslmsl;
        }

        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment.utc(previ.date).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index === forecasts.length - 1)
        ) {
          actualNight.to = moment.utc(forecasts[index - 1].date).unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });
      series.push({
        color: "#0037ff",
        data: pressure,
        yAxis: 0,
        name: this.$t("forecasts.pressureChart.title1"),
      });

      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];

            this.points.forEach((point, index) => {
              console.log(index)
              tooltipArray.push(
                point.series.name + ": " + point.y.toFixed(1) + "</b>"
              );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          ordinal: false,
          plotLines: [
            {
              value: new Date(),
              width: 1,
              color: "green",
              dashStyle: "dash",
              label: {
                text: "Actuellement",
                align: "right",
                y: 100,
                x: 0,
              },
            },
          ],
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            tickAmount: 3,
            tickInterval: 10,
            max: max,
            min: min,
            labels: {
              format: "{value}",
            },
            opposite: false,
            title: {
              text: this.$t("forecasts.pressureChart.legend1"),
            },
          },
          {
            tickAmount: 3,
            tickInterval: 10,
            max: max,
            min: min,
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("forecasts.pressureChart.legend1"),
            },
          },
        ],
        // Labels Options
        plotOptions: {
          line: {
            enableMouseTracking: true,
          },
        },

        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                yAxis: {
                  labels: {
                    align: "left",
                    x: 0,
                    y: -5,
                  },
                  title: {
                    text: null,
                  },
                },
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            },
          ],
        },
      };
    },

    tickArray() {
      let forecasts = this.forecasts;

      let res = [];

      forecasts.forEach((chunk) => {
        if (
          moment.utc(chunk.date).local().hours() === 0 ||
          moment.utc(chunk.date).local().hours() === 12
        ) { 
          res.push(moment.utc(chunk.date).unix() * 1000);
        }
      });

      return res;
    },
  },

  methods: {

    /**
     * Fetch API, get forecasts & select only wanted time
     */
    async getForecasts() {
      this.isLoading = true;
      this.userAlerts = [] 
      let res = await api.alert.getMapAlerts(this.user.id_user);
      let alert = res.find(map=>map.geoname == this.$route.params.geoname);

      if(alert)
      {this.userAlerts = alert.config}
      this.forecasts = [];
      try {
        let result = await api.forecast.get(this.$route.params.geoname, 3, this.model);
          
        result.short.forEach((fcast) => {
          this.forecasts.push(fcast);
        });

        result.long = result.long.filter((fcast) =>
          moment.utc(fcast.date).unix() > moment.utc(result.short[result.short.length - 1].date).unix()
        );

        if(this.user.features.find((map) => map == 'forecast_14'))
        {
          result.long.forEach((fcast)=>{
            this.forecasts.push(fcast)
          })
        }
          this.isLoading = false;
      } catch (err) {
        console.error(err.message);
        this.isLoading = false;
      }
        this.isLoading = false;
      this.$nextTick(() => {
        if (this.$vuetify.breakpoint.mobile) {
          this.loading = false;
          // this.$refs.highchart.chart.xAxis[0].setExtremes(0, 72, true,);
          this.$refs.highchart.chart.xAxis[0].setExtremes(moment().set({minute:0, seconds:0}).unix() * 1000, moment().add(2, 'days').set({minute:0, seconds:0}).unix() * 1000, true);
        }else{

          this.$refs.highchart.chart.xAxis[0].setExtremes(moment().set({minute:0, seconds:0}).unix() * 1000, moment().add(7, 'days').set({minute:0, seconds:0}).unix() * 1000, true);
        }
      });
    },
    cardinals,

    getArrow(str) {
      switch (str) {
        case "N":
          return 0;
        case "NNE":
          return 22.5;
        case "NE":
          return 45;
        case "ENE":
          return 67.5;
        case "E":
          return 90;
        case "ESE":
          return 112.5;
        case "SE":
          return 135;
        case "SSE":
          return 157.5;
        case "S":
          return 180;
        case "SSO":
          return 202.5;
        case "SO":
          return 225;
        case "OSO":
          return 247.5;
        case "O":
          return 270;
        case "ONO":
          return 292.5;
        case "NO":
          return 315;
        case "NNO":
          return 337.5;

        default:
          return "-";
      }
    },

    syncExtremes: function (e) {
      var thisChart = this.chart;
      if (e.trigger !== "syncExtremes") {
        // Prevent feedback loop
        Highcharts.each(Highcharts.charts, function (chart) {
          if (chart !== thisChart) {
            if (chart.xAxis[0].setExtremes) {
              // It is null while updating
              console.log(e.min, e.max)
              chart.xAxis[0].setExtremes(e.min, e.max, undefined, false, {
                trigger: "syncExtremes",
              });
            }
          }
        });
      }
    },

    formatIcon(index) {
      if (this.forecasts[index].is_night) {
        return iconUrl(this.forecasts[index].ts, true);
      } else {
        return iconUrl(this.forecasts[index].ts);
      }
    },
  },

  setup() {
    const titleStack = ref(["Admin", "Prévisions"]);

    return {
      titleStack,
    };
  },

  mounted() {
    this.getForecasts();
  },
  watch:{
    model(){
      // this.getForecasts();
    }
  }
};
</script>

<style>
.highcharts-label.highcharts-data-label.highcharts-data-label-color-undefined.highcharts-tracker {
  top: 0 !important;
}
</style>
